var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProduction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10511_39746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6901 1.08505C11.5723 1.00596 11.4354 0.960046 11.2938 0.952128C11.1521 0.94421 11.011 0.974581 10.8851 1.04005C10.2284 1.31123 9.52981 1.46685 8.82011 1.50005C8.01174 1.43713 7.21502 1.26905 6.45011 1.00005C4.77011 0.500053 4.19012 0.385053 2.90512 0.550053C2.72438 0.574203 2.55849 0.662945 2.43809 0.799886C2.3177 0.936827 2.25092 1.11271 2.25012 1.29505V8.79505C2.24822 8.90247 2.26959 9.00902 2.31274 9.10741C2.35589 9.2058 2.41981 9.29369 2.50012 9.36505C2.57941 9.43485 2.67239 9.48736 2.77312 9.51921C2.87384 9.55106 2.9801 9.56157 3.08512 9.55005C4.21512 9.42005 4.74011 9.55005 6.30511 9.99005C7.11279 10.2661 7.9534 10.4342 8.80511 10.4901C9.68019 10.4581 10.5416 10.2631 11.3451 9.91505C11.6801 9.78505 11.9851 9.61505 11.9851 9.15005V1.70005C11.9881 1.58152 11.9629 1.46398 11.9116 1.35708C11.8603 1.25017 11.7844 1.15695 11.6901 1.08505Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 0C0.551088 0 0.360322 0.0790176 0.21967 0.21967C0.0790176 0.360322 0 0.551088 0 0.75L0 11.25C0 11.4489 0.0790176 11.6397 0.21967 11.7803C0.360322 11.921 0.551088 12 0.75 12C0.948912 12 1.13968 11.921 1.28033 11.7803C1.42098 11.6397 1.5 11.4489 1.5 11.25V0.75C1.5 0.551088 1.42098 0.360322 1.28033 0.21967C1.13968 0.0790176 0.948912 0 0.75 0Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10511_39746"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduction);
export default __webpack_public_path__ + "static/media/production.23c642d1.svg";
export { ForwardRef as ReactComponent };